const CanceledTicketIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#F0F3F9" />
      <path
        d="M15.9998 7.66675C20.6022 7.66675 24.3332 11.3977 24.3332 16.0001C24.3332 20.6025 20.6022 24.3334 15.9998 24.3334C11.3975 24.3334 7.6665 20.6025 7.6665 16.0001M13.424 8.07247C12.5832 8.34548 11.801 8.74855 11.1011 9.25792M9.2577 11.1013C8.74822 11.8013 8.3451 12.5837 8.07209 13.4247"
        stroke="#455468"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.4995 18.5L13.5 13.5M13.5005 18.5L18.5 13.5"
        stroke="#455468"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CanceledTicketIcon;
